// extracted by mini-css-extract-plugin
module.exports = {"customDropdownInput":"styles_customDropdownInput__3yCFP","customDropdownPrefix":"styles_customDropdownPrefix__2OArI","customDropdownArrow":"styles_customDropdownArrow__2tLED"};